import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule, MatGridListModule } from '@angular/material';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import {
    ModalLogoutComponent,
    ContentHeaderComponent,
    ContentListComponent,
    ModalConfirmComponent,
    LoadingComponent,
    LoadingGlobalComponent
} from './components';

import {
    AppExpandMenu,
    AppExpandSidebar,
    FilterGeneralPipe,
    SearchPipe,
    OrderByPipe
} from './pipes';
import { ComboBoxLoadingComponent } from './components/combo-box-loading/combo-box-loading.component';
import { FlowchartComponent } from './components/flowchart/flowchart.component';
import { FlowchartViewerComponent } from './components/flowchart-viewer/flowchart-viewer.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        AngularFontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatGridListModule,
        RouterModule,
        NgxPaginationModule,
        TranslateModule
    ],
    declarations: [
        ModalLogoutComponent,
        AppExpandMenu,
        AppExpandSidebar,
        ContentHeaderComponent,
        ContentListComponent,
        FilterGeneralPipe,
        SearchPipe,
        ModalConfirmComponent,
        OrderByPipe,
        LoadingComponent,
        LoadingGlobalComponent,
        ComboBoxLoadingComponent,
        FlowchartComponent,
        FlowchartViewerComponent
    ],
    exports: [
        ModalLogoutComponent,
        AppExpandMenu,
        AppExpandSidebar,
        ContentHeaderComponent,
        ContentListComponent,
        FilterGeneralPipe,
        SearchPipe,
        ModalConfirmComponent,
        OrderByPipe,
        LoadingComponent,
        LoadingGlobalComponent,
        FlowchartComponent,
        FlowchartViewerComponent
    ],
    entryComponents: [
        ModalLogoutComponent,
        ModalConfirmComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule {}
